import React, { useState, useRef, useEffect } from 'react';
import './NIPage.css';
import { commonrequest } from '../../services/ApiCall';
import { BACKEND_URL } from '../../services/Helper';

const SUGGESTIONS = [
  '🍕 Best pizza places near me',
  '✂️ Salons with good offers today',
  '🏪 Kirana stores open now',
  '💰 Shops with biggest discounts',
  '🍽️ What food is available nearby?',
  '💪 Gyms and fitness centres near me',
];

const NIPage = () => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState(null);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (pos) => setLocation({ lat: pos.coords.latitude, lng: pos.coords.longitude }),
        () => setLocation(null)
      );
    }
  }, []);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages, loading]);

  const send = async (text) => {
    const query = (text || input).trim();
    if (!query || loading) return;

    setInput('');
    setMessages((prev) => [...prev, { role: 'user', text: query }]);
    setLoading(true);

    try {
      const body = { query };
      if (location) {
        body.userLat = location.lat;
        body.userLng = location.lng;
      }
      const res = await commonrequest('POST', `${BACKEND_URL}/nearbe/ni/chat`, body, {});
      const reply = res?.data?.reply || "Sorry, I couldn't find anything right now. Try again!";
      setMessages((prev) => [...prev, { role: 'assistant', text: reply }]);
    } catch {
      setMessages((prev) => [...prev, { role: 'assistant', text: "Something went wrong. Please try again." }]);
    } finally {
      setLoading(false);
    }
  };

  const handleKey = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  };

  return (
    <div className="ni-page">
      <div className="ni-header">
        <div className="ni-header-left">
          <div className="ni-logo">NI</div>
          <div>
            <p className="ni-header-title">Nearbeee Intelligence</p>
            <p className="ni-header-sub">Your hyperlocal AI assistant</p>
          </div>
        </div>
        <div className="ni-live-badge">
          <div className="ni-live-dot" />
          <span className="ni-live-text">LIVE</span>
        </div>
      </div>

      <div className="ni-messages" ref={scrollRef}>
        {messages.length === 0 && (
          <div className="ni-welcome">
            <div className="ni-logo" style={{ width: 64, height: 64, fontSize: 20, borderRadius: 18, marginBottom: 16 }}>NI</div>
            <p className="ni-welcome-title">Hi, I'm NI</p>
            <p className="ni-welcome-text">
              Ask me anything about shops, offers, food,<br />
              or services near you — I'll find the best options.
            </p>
            <div className="ni-suggestions">
              {SUGGESTIONS.map((s) => (
                <button
                  key={s}
                  className="ni-suggestion-chip"
                  onClick={() => send(s)}
                >
                  {s}
                </button>
              ))}
            </div>
          </div>
        )}

        {messages.map((msg, i) => (
          <div key={i} className={`ni-bubble ${msg.role}`}>
            {msg.role === 'assistant' && (
              <div className="ni-avatar-small">NI</div>
            )}
            <div className="ni-bubble-inner">{msg.text}</div>
          </div>
        ))}

        {loading && (
          <div className="ni-bubble assistant">
            <div className="ni-avatar-small">NI</div>
            <div className="ni-bubble-inner ni-typing">
              <div className="ni-typing-dot" />
              <div className="ni-typing-dot" />
              <div className="ni-typing-dot" />
            </div>
          </div>
        )}
      </div>

      <div className="ni-input-bar">
        <input
          className="ni-input"
          placeholder="Ask about shops, offers, food..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={handleKey}
          disabled={loading}
        />
        <button
          className="ni-send-btn"
          onClick={() => send()}
          disabled={!input.trim() || loading}
          aria-label="Send"
        >
          ↑
        </button>
      </div>
    </div>
  );
};

export default NIPage;
